var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 560 560",
    xmlns: "http://www.w3.org/2000/svg",
    strokeMiterlimit: 1.414,
    strokeLinejoin: "round",
    id: "plex-icon-search-560",
    "aria-hidden": "true",
    className: "PlexIcon-plexIcon-8Tamaj QuickSearchInput-searchIcon-38PAh5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M351.883,407.883C315.613,433.168 271.525,448 224,448C100.371,448 0,347.629 0,224C0,100.371 100.371,0 224,0C347.629,0 448,100.371 448,224C448,271.525 433.168,315.613 407.883,351.883L560,504L504,560L351.883,407.883ZM56,224C56,316.722 131.278,392 224,392C316.722,392 392,316.722 392,224C392,131.278 316.722,56 224,56C131.278,56 56,131.278 56,224Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.68cc60ba.svg";
export { ForwardRef as ReactComponent };